// Deutsch
export default {
    // Research papers page (/research)
    "nav.globe": "Globus",
    "nav.research": "Forschung",
    "rs.title": "Forschungsarbeiten",
    "rs.sub": "Neue Forschung zu quantitativer Finanz und Zentralbanken von arXiv, Fed, EZB, BIZ und NBER. Kostenlos an der Quelle lesbar; alle 6 Stunden aktualisiert.",
    "rs.search": "Titel, Autoren, Zusammenfassungen suchen…",
    "rs.allTopics": "Alle Themen",
    "rs.allSources": "Alle Quellen",
    "rs.allCountries": "Alle Länder",
    "rs.count": "{n} Arbeiten",
    "rs.none": "Keine Arbeiten passen zu diesen Filtern.",
    "rs.clear": "Filter zurücksetzen",
    "rs.download": "PDF bei {source} herunterladen",
    "rs.read": "Bei {source} lesen",
    "rs.onGlobe": "{country} auf dem Globus öffnen",
    "rs.note": "Titel, Autoren und Zusammenfassungen verlinken auf die Originalquellen; PDFs öffnen sich auf deren Websites. Forschung, keine Anlageberatung.",
    "rs.global": "Global",
    "rs.loadMore": "Mehr laden",
    "rs.details": "Details",
    "rs.copy": "Link kopieren",
    "rs.copied": "Link kopiert",
    "rs.published": "Veröffentlicht",
    "panel.research": "Forschung zu {country}",
    "panel.researchAll": "Alle Forschung →",
    "rt.trading": "Handel & Marktstruktur",
    "rt.portfolio": "Portfolios & Geldanlage",
    "rt.risk": "Risiko",
    "rt.pricing": "Derivate & Bewertungsmodelle",
    "rt.forecasting": "KI & Prognosen",
    "rt.crypto": "Krypto & digitale Vermögenswerte",
    "rt.macro": "Wirtschaft & Zentralbanken",
    "topic.r-trading": "Handelsforschung untersucht, wie Preise entstehen und Aufträge ausgeführt werden: Strategien, Orderbücher, Liquidität und Handelskosten.",
    "topic.r-portfolio": "Portfolioforschung fragt, wie man Anlagen kombiniert: welche Faktoren Renditen erklären, wie man Risiko und Rendite abwägt und wie man für die Rente anlegt.",
    "topic.r-risk": "Risikoforschung misst, was schiefgehen kann: große Verluste, Crashs, Bankpleiten und wie man sich schützt.",
    "topic.r-pricing": "Bewertungsforschung entwickelt die Mathematik, mit der Optionen und andere Kontrakte bewertet werden, und Volatilitätsmodelle.",
    "topic.r-forecasting": "Forschung zu KI und Prognosen prüft, ob maschinelles Lernen, Sprachmodelle und Statistik Preise oder die Wirtschaft vorhersagen können, und wie zuverlässig.",
    "topic.r-crypto": "Kryptoforschung untersucht Kryptowährungen, Stablecoins, Blockchains und tokenisierte Vermögenswerte: wie sie gehandelt werden und welche Risiken sie bergen.",
    "topic.r-macro": "Wirtschaftsforschung betrachtet Wachstum, Inflation, Zinsen und Zentralbankpolitik, die die Märkte über Monate und Jahre bewegen.",
    'lang.label': 'Sprache',
    'nav.reports': 'Berichte',
    'nav.stocks': 'Aktien-Watch',
    loading: 'Weltnachrichten werden geladen…',
    'err.title': 'Laden fehlgeschlagen',
    'err.msg': 'Beim Laden der Anwendung ist ein Fehler aufgetreten.',
    'err.retry': 'Erneut versuchen',
    atlas: 'Atlas',
    'search.label': 'Länder suchen',
    'search.ph': 'Länder oder Codes suchen…',
    'filter.region': 'Region',
    'filter.allRegions': 'Alle Regionen',
    'filter.window': 'Zeitraum',
    'filter.topic': 'Thema',
    'filter.all': 'Alle',
    'stage.title': 'Die Märkte, jetzt',
    legend: 'Legende',
    lastUpdate: 'Letzte Aktualisierung',
    pauseRotation: 'Drehung anhalten',
    resumeRotation: 'Drehung fortsetzen',
    hint: 'Ziehen zum Drehen · auf einen Punkt klicken, um ein Land zu öffnen',
    'panel.latest': 'Neueste',
    'quiet.none': 'Keine Meldungen in diesem Zeitraum.',
    'quiet.sub': 'Wähle einen längeren Zeitraum (7T oder 30T) oder folge diesem Land, um es in deiner Liste zu behalten.',
    'footer.about': 'Über uns',
    'footer.privacy': 'Datenschutz',
    'footer.terms': 'Bedingungen',
    follow: '☆ Folgen',
    following: '★ Gefolgt',
    followingGroup: 'Gefolgt',
    explain: 'Erklär mir das',
    hideExplain: 'Erklärung ausblenden',
    share: 'Teilen',
    whyMatter: 'Warum es wichtig sein kann',
    disclaimer: 'Bildungsinhalt, keine Finanzberatung.',
    readAt: 'Ganze Meldung bei {source} lesen',
    translate: 'Übersetzen',
    showing: '{n} von {total} angezeigt',
    loadMore: '{n} weitere laden',
    loadingShort: 'Wird geladen…',
    'story.one': '{n} Meldung',
    'story.other': '{n} Meldungen',
    noStories: 'keine Meldungen',
    justNow: 'Gerade eben',
    minAgo: 'vor {n} Min.',
    hAgo: 'vor {n} Std.',
    dAgo: 'vor {n} T.',
    'range.24h': 'letzte 24 Stunden',
    'range.7d': 'letzte 7 Tage',
    'range.30d': 'letzte 30 Tage',
    'range.all': 'gesamter Zeitraum',
    'cont.Africa': 'Afrika',
    'cont.Asia': 'Asien',
    'cont.Europe': 'Europa',
    'cont.North America': 'Nordamerika',
    'cont.Oceania': 'Ozeanien',
    'cont.South America': 'Südamerika',
    'cat.markets': 'Märkte',
    'cat.economy': 'Wirtschaft',
    'cat.central-banks': 'Zentralbanken',
    'cat.policy': 'Politik & Geopolitik',
    'cat.companies': 'Unternehmen',
    today: 'Heute',
    'today.top': 'Die Welt in 60 Sekunden',
    'today.banks': 'Zentralbank-Entscheidungen',
    'today.mine': 'Deine Länder',
    'today.emptyTop': 'Heute noch keine wichtigen Meldungen. Schau bald wieder vorbei.',
    'today.emptyMine': 'Tippe bei einem Land auf ☆ Folgen, um es hier anzuheften.',
    'today.note': 'Schlagzeilen verlinken auf die Originalquellen. Nur Bildungsinhalt, keine Finanzberatung.',
    'today.open': '{country} öffnen',
    close: 'Schließen',
    'cal.timeVaries': 'Uhrzeit variiert',
    'cal.yourTime': '{time} deine Zeit',
    'cal.in': 'in {t}',
    'cal.today': 'Entscheidung heute',
    'bank.fed': 'Federal Reserve',
    'bank.ecb': 'Europäische Zentralbank',
    'bank.boe': 'Bank of England',
    'bank.boj': 'Bank of Japan',
    'auth.signIn': 'Anmelden',
    'auth.account': 'Konto',
    'auth.btnTitle': 'Kostenloses Konto: deine Länder auf allen Geräten speichern',
    'auth.freeTitle': 'Kostenloses Konto',
    'auth.freeSub': "Speichere die Länder, denen du folgst, auf all deinen Geräten. Kein Passwort: Wir schicken dir einen Einmalcode per E-Mail.",
    'auth.emailBtn': "Anmeldecode per E-Mail senden",
    'auth.sending': 'Wird gesendet…',
    'auth.check': 'Prüfe dein Postfach: Der Link läuft nach 20 Minuten ab.',
    "auth.codeTitle": "Prüfe deine E-Mails",
    "auth.codeSent": "Wir haben einen 6-stelligen Code an {email} geschickt. Gib ihn hier ein:",
    "auth.codeLabel": "Anmeldecode",
    "auth.codeBtn": "Anmelden",
    "auth.junk": "Nicht da? Es kann eine Minute dauern. Schau auch im Spam- oder Junk-Ordner nach und markiere die E-Mail als \"Kein Spam\", damit die nächsten im Posteingang landen.",
    "auth.otherEmail": "Andere E-Mail verwenden",
    'auth.dev': 'Entwicklungsmodus (kein Mailserver):',
    'auth.devLink': 'hier klicken, um dich anzumelden',
    'auth.fine': 'Wir nutzen deine E-Mail nur für die Anmeldung. Siehe {link}.',
    'auth.privacy': 'Datenschutzhinweis',
    'auth.yourAccount': 'Dein Konto',
    'auth.signedInAs': 'Angemeldet als {email}',
    'auth.followCount': 'Du folgst {n} Ländern, synchronisiert auf all deinen Geräten.',
    'auth.signOut': 'Abmelden',
    'auth.delete': 'Mein Konto löschen',
    "auth.confirmDelete": "Konto löschen? Deine E-Mail-Adresse und gespeicherten Länder werden gelöscht, und du erhältst keine E-Mails von NewsNetWide mehr. Das kann nicht rückgängig gemacht werden.",
    'auth.deletedTitle': 'Konto gelöscht',
    "auth.deletedSub": "Deine E-Mail-Adresse, deine gespeicherten Länder und dein E-Mail-Abo wurden gelöscht.",
    'auth.inTitle': 'Du bist angemeldet',
    'auth.inSub': 'Willkommen, {email}. Die Länder, denen du folgst, sind jetzt in deinem Konto gespeichert.',
    'auth.expired': 'Dieser Link ist abgelaufen. Fordere unten einen neuen an.',
    'auth.used': 'Dieser Link wurde bereits verwendet oder ist ungültig. Fordere unten einen neuen an.',
    'share.source': 'Quelle',
    'share.tagline': 'Jede marktbewegende Meldung auf einem Globus',
    'share.notAdvice': 'Nachrichten, keine Finanzberatung',
    'mc.open': 'Geöffnet',
    'mc.pre': 'Vorbörse',
    'mc.post': 'Nachbörse',
    'mc.night': 'Nachthandel',
    'mc.break': 'Mittagspause',
    'mc.closed': 'Geschlossen',
    'mc.holiday': 'Feiertag',
    'mc.closesIn': 'Schließt in {t}',
    'mc.opensIn': 'Öffnet in {t}',
    'mc.endsIn': 'Endet in {t}',
    'mc.reopensIn': 'Öffnet wieder in {t}',
    'mc.preIn': 'Vorbörse in {t}',
    'mc.afterIn': 'Nachbörse in {t}',
    'mc.nightIn': 'Nachthandel in {t}',
    'mc.openCount': '{n} geöffnet',
    'mc.all': 'Alle Märkte',
    "mc.title": "Börsenzeiten",
    "side.countries": "Länder",
    "side.menu": "Menü",
    "tools.pricingSub": "Die Tarife und was sie enthalten",
    'mc.noHolidays': 'ohne Feiertage',
    'mc.local': 'Ortszeit',
    'mc.note': 'Reguläre Handelszeiten in der Ortszeit jeder Börse. Feiertage sind für die Märkte in den USA, Großbritannien, Deutschland und Euronext Paris enthalten (2026–27); andere Börsen können an lokalen Feiertagen geschlossen sein. Nachtsitzungen sind Index-Futures-Sitzungen (Tokio OSE, Hongkong HKFE).',
    'topic.markets': 'Marktnachrichten betreffen die Preise von Aktien, Anleihen, Währungen und Rohstoffen: was Anleger kaufen und verkaufen, und warum.',
    'topic.economy': 'Wirtschaftsnachrichten (Wachstum, Arbeitsmarkt, Inflation, Handel) prägen Unternehmensgewinne und Zentralbankentscheidungen der kommenden Monate.',
    'topic.central-banks': 'Zentralbanken legen die Zinsen fest, den Preis des Geldes, der Kredite, Ersparnisse, Währungen und Vermögenspreise beeinflusst.',
    'topic.policy': 'Regierungsentscheidungen (Steuern, Haushalte, Handelsregeln, Sanktionen, Wahlen, Konflikte) können Kosten und Risiken ganzer Branchen verändern.',
    'topic.companies': 'Unternehmensnachrichten (Ergebnisse, Übernahmen, Stellenabbau) können die Aktie und manchmal die ganze Branche bewegen.',
    "snap.title": "Anleger-Überblick",
    "snap.source": "Neueste offizielle Jahreswerte · World Bank Open Data. Kontext, keine Prognose oder Beratung.",
    "snap.gdp_growth": "BIP-Wachstum",
    "snap.inflation": "Inflation",
    "snap.unemployment": "Arbeitslosigkeit",
    "snap.gdp_per_capita": "BIP pro Kopf",
    "snap.current_account": "Leistungsbilanz",
    "snap.exports": "Exporte",
    "snap.ofGdp": "des BIP",
    "snap.gdp.shrink": "Die Wirtschaft schrumpft.",
    "snap.gdp.slow": "Langsames Wachstum.",
    "snap.gdp.moderate": "Moderates Wachstum.",
    "snap.gdp.fast": "Schnelles Wachstum.",
    "snap.inf.deflation": "Die Preise sinken (Deflation).",
    "snap.inf.target": "Nahe den ~2 %, die die meisten Zentralbanken anstreben.",
    "snap.inf.above": "Über den üblichen Zielen der Zentralbanken.",
    "snap.inf.high": "Hohe Inflation: Geld verliert schnell an Wert.",
    "snap.unemp.low": "Niedrig: Der Arbeitsmarkt ist angespannt.",
    "snap.unemp.moderate": "Moderat.",
    "snap.unemp.high": "Hoch: Viele Menschen finden keine Arbeit.",
    "snap.gdppc.note": "Durchschnittliche Wirtschaftsleistung pro Person: ein grobes Maß für den Wohlstand eines Landes.",
    "snap.ca.surplus": "Überschuss: nimmt im Ausland mehr ein, als es ausgibt.",
    "snap.ca.deficit": "Defizit: gibt im Ausland mehr aus, als es einnimmt, und ist auf ausländisches Geld angewiesen.",
    "snap.exp.very": "Stark handelsabhängig: empfindlich gegenüber Zöllen und globaler Nachfrage.",
    "snap.exp.open": "Eine offene, handelnde Volkswirtschaft.",
    "snap.exp.domestic": "Vor allem vom Binnenmarkt getragen.",
    "auth.since": "Mitglied seit {date}",
    "auth.followed": "Länder, denen du folgst",
    "auth.noneFollowed": "Noch keine. Tippe bei einem Land auf ☆ Folgen, um es hier hinzuzufügen.",
    "auth.unfollow": "{country} nicht mehr folgen",
    "auth.email": "E-Mail",
    "auth.prefUpdates": "NewsNetWide-Updates",
    "auth.prefUpdatesSub": "Neue Funktionen und Neuigkeiten zur Website",
    "auth.prefNews": "Newsletter",
    "auth.prefNewsSub": "Die wichtigsten Marktnachrichten",
    "auth.saved": "Gespeichert.",
    "auth.prefsError": "E-Mail-Einstellungen sind gerade nicht verfügbar.",
    "auth.plan": "Tarif",
    "auth.seePlans": "Tarife ansehen",
    "auth.manage": "Abo verwalten",
    "auth.trialUntil": "kostenlos testen bis {date}",
    "auth.renews": "verlängert sich am {date}",
    "auth.endsOn": "endet am {date}",
    "auth.briefing": "Morgen-Briefing",
    "auth.briefingOn": "Schick mir jeden Morgen ein Briefing",
    "auth.briefingSub": "Die wichtigsten Nachrichten aus den Ländern, denen du folgst, und die nächsten wichtigen Termine. Jederzeit abbestellbar.",
    "auth.briefingNone": "Du folgst noch keinem Land, daher beginnt es mit den wichtigsten Nachrichten der Welt.",
    "auth.briefingCount": "Länder in deinem Briefing: {n}",
    "auth.briefingAt": "Senden um",
    "auth.briefingTz": "deine Zeit ({tz})",
    "auth.briefingPreview": "Heutiges Beispiel ansehen ↗",
    "panel.page": "Länderseite ↗",
    "footer.countries": "Länder",
    glossary: {
        'central-bank': ['Zentralbank', 'Die Institution, die die Zinsen eines Landes festlegt und die Geldmenge steuert.', 'Ihre Entscheidungen verändern die Kreditkosten für alle und bewegen Anleihen, Aktien und die Währung.'],
        fed: ['Federal Reserve (Fed)', 'Die Zentralbank der USA; ihr Ausschuss (FOMC) legt die US-Zinsen fest.', 'US-Zinsen beeinflussen Kreditkosten und Kapitalströme weltweit.'],
        ecb: ['Europäische Zentralbank (EZB)', 'Die Zentralbank der 20 Länder mit dem Euro.', 'Ihre Zinsentscheidungen wirken auf Hypotheken, Unternehmenskredite und den Euro.'],
        boe: ['Bank of England', 'Die Zentralbank Großbritanniens; ihr geldpolitischer Ausschuss legt die britischen Zinsen fest.', 'Ihre Entscheidungen bewegen das Pfund, britische Staatsanleihen und die Kreditkosten.'],
        boj: ['Bank of Japan', 'Die Zentralbank Japans.', 'Änderungen an Japans sehr niedrigen Zinsen können den Yen und globale Kapitalströme bewegen.'],
        'interest-rate': ['Zinssatz', 'Der Preis für geliehenes Geld, meist als Prozentsatz pro Jahr.', 'Höhere Zinsen verteuern Kredite und bremsen oft den Konsum; niedrigere bewirken das Gegenteil.'],
        'rate-cut': ['Zinssenkung', 'Eine Zentralbank senkt ihren Leitzins.', 'Günstigere Kredite können Konsum und Gewinne stützen, aber auch Sorgen um die Konjunktur signalisieren.'],
        'rate-hike': ['Zinserhöhung', 'Eine Zentralbank erhöht ihren Leitzins.', 'Ziel ist meist, die Inflation zu bremsen; Kredite werden für Haushalte und Firmen teurer.'],
        'basis-points': ['Basispunkte', 'Ein Basispunkt ist 0,01 %; 25 Basispunkte sind ein Viertelprozentpunkt.', 'Zinsänderungen werden in Basispunkten angegeben und zeigen so die Größe der Bewegung.'],
        qe: ['Quantitative Lockerung (QE)', 'Eine Zentralbank kauft (QE) oder reduziert (QT) große Mengen an Anleihen, um die langfristigen Zinsen zu beeinflussen.', 'Das verändert, wie viel Geld durch die Finanzmärkte fließt.'],
        inflation: ['Inflation', 'Das Tempo, mit dem die Preise steigen; meist gemessen am Verbraucherpreisindex (VPI).', 'Hohe Inflation kann Zentralbanken zu hohen Zinsen bewegen und mindert die Kaufkraft.'],
        gdp: ['BIP', 'Bruttoinlandsprodukt: der Gesamtwert aller Waren und Dienstleistungen einer Volkswirtschaft.', 'Es ist das umfassendste Maß dafür, ob eine Wirtschaft wächst oder schrumpft.'],
        recession: ['Rezession', 'Ein deutlicher, breiter Rückgang der Wirtschaftsleistung, oft zwei Quartale mit sinkendem BIP.', 'Rezessionen bedeuten meist schwächere Gewinne und höhere Arbeitslosigkeit.'],
        unemployment: ['Arbeitslosigkeit', 'Der Anteil der Menschen, die arbeiten wollen, aber keine Stelle haben; Beschäftigtenzahlen zählen neue Jobs.', 'Arbeitsmarktdaten zeigen die Stärke der Wirtschaft und beeinflussen die Zentralbanken.'],
        pmi: ['Einkaufsmanagerindex (PMI)', 'Monatliche Umfrage zur Geschäftstätigkeit. Über 50 bedeutet Wachstum.', 'Er ist eines der frühesten Signale, wohin die Wirtschaft steuert.'],
        'trade-deficit': ['Handelsbilanz', 'Die Differenz zwischen den Exporten und Importen eines Landes.', 'Große Ungleichgewichte können die Währung beeinflussen und zu Handelsstreit führen.'],
        tariff: ['Zoll', 'Eine Steuer auf importierte Waren.', 'Zölle verteuern Importe und können Umsätze und Gewinne von Exporteuren schmälern.'],
        sanctions: ['Sanktionen', 'Beschränkungen, die ein Land dem Handel oder Finanzverkehr mit einem anderen auferlegt.', 'Sie können Märkte abschneiden, Lieferketten stören und Rohstoffpreise bewegen.'],
        budget: ['Haushalt & Fiskalpolitik', 'Wie ein Staat Steuern erhebt, ausgibt und Schulden macht.', 'Hohe Defizite oder Konjunkturpakete können Wachstum, Anleiherenditen und Währung beeinflussen.'],
        'bond-yield': ['Anleiherendite', 'Die Rendite eines Anleiheinvestors; fallen die Anleihekurse, steigen die Renditen.', 'Staatsanleiherenditen bestimmen die Grundkosten für Kredite in der ganzen Wirtschaft.'],
        index: ['Aktienindex', 'Ein Korb von Aktien, der einen Markt abbildet, etwa der S&P 500 (500 große US-Unternehmen).', 'Indizes fassen die Entwicklung eines ganzen Marktes in einer Zahl zusammen.'],
        'sell-off': ['Ausverkauf', 'Eine Phase, in der viele Anleger gleichzeitig verkaufen und die Kurse schnell fallen.', 'Er spiegelt oft Angst oder schlechte Nachrichten; über die Zukunft sagt er nichts Sicheres.'],
        volatility: ['Volatilität', 'Wie stark und wie schnell Preise schwanken.', 'Höhere Volatilität bedeutet mehr Unsicherheit und größere Ausschläge in beide Richtungen.'],
        currency: ['Wechselkurs', 'Der Preis einer Währung in einer anderen.', 'Währungsbewegungen verändern Importkosten, Reisekosten und den Wert ausländischer Anlagen.'],
        oil: ['Ölpreis', 'Der Marktpreis für Rohöl; Brent und WTI sind die Referenzsorten. Die OPEC ist ein Zusammenschluss von Förderländern.', 'Öl beeinflusst Treibstoff-, Transport- und Produktionskosten und damit die Inflation.'],
        gold: ['Gold', 'Gold als gehandelter Rohstoff.', 'Viele Anleger kaufen es in unsicheren Zeiten; der Preis spiegelt daher oft Nervosität.'],
        crypto: ['Kryptowährung', 'Digitale Werte wie Bitcoin, die rund um die Uhr ohne Zentralbank gehandelt werden.', 'Die Preise sind sehr schwankungsanfällig und reagieren auf Regulierung und Risikobereitschaft.'],
        etf: ['ETF', 'Ein börsengehandelter Fonds, der meist einen Index abbildet.', 'ETFs sind ein verbreiteter, günstiger Weg, in einen ganzen Markt zu investieren.'],
        earnings: ['Gewinne', 'Der gemeldete Gewinn eines Unternehmens für einen Zeitraum, oft je Aktie.', 'Ergebnisse über oder unter den Erwartungen der Analysten bewegen oft den Aktienkurs.'],
        revenue: ['Umsatz', 'Alle Einnahmen eines Unternehmens aus dem Verkauf seiner Produkte oder Dienste, vor Kosten.', 'Umsatzwachstum zeigt, ob die Nachfrage nach den Produkten steigt.'],
        guidance: ['Prognose', 'Die eigene Vorhersage eines Unternehmens für künftige Ergebnisse.', 'Änderungen der Prognose zählen für Anleger oft so viel wie die vergangenen Zahlen.'],
        ipo: ['Börsengang (IPO)', 'Wenn ein Unternehmen erstmals Aktien an einer Börse verkauft.', 'Die Öffentlichkeit kann dann investieren; er zeigt das Interesse an neuen Börsengängen.'],
        merger: ['Fusionen & Übernahmen', 'Ein Unternehmen schließt sich mit einem anderen zusammen oder kauft es.', 'Deals können den Wettbewerb verändern und bewegen oft die Aktien beider Firmen.'],
        buyback: ['Aktienrückkauf', 'Ein Unternehmen kauft eigene Aktien vom Markt zurück.', 'Er gibt Geld an Aktionäre zurück und verringert die Aktienzahl; eine Wertgarantie ist er nicht.'],
        dividend: ['Dividende', 'Ein Teil des Gewinns, der an die Aktionäre ausgeschüttet wird.', 'Dividendenänderungen zeigen, wie zuversichtlich ein Unternehmen bei seinen Finanzen ist.'],
        layoffs: ['Stellenabbau', 'Ein Unternehmen verringert die Zahl seiner Beschäftigten.', 'Er kann auf Kostendruck oder Umbau hindeuten und wirkt auf den Arbeitsmarkt.'],
        bankruptcy: ['Insolvenz', 'Ein rechtliches Verfahren, wenn ein Unternehmen seine Schulden nicht zahlen kann.', 'Aktionäre verlieren meist fast alles; Gläubiger erhalten oft nur einen Teil zurück.'],
    },
    // Calendar (/calendar)
    "nav.calendar": "Kalender",
    "nav.tools": "Tools",
    "nav.pricing": "Preise",
    "tools.soon": "BALD",
    "tools.briefing": "Morgen-Briefing",
    "tools.briefingSub": "Nachrichten deiner Länder per E-Mail, jeden Morgen",
    "tools.calculators": "Finanzrechner",
    "tools.calculatorsSub": "Zinseszins, Sparziele, Gebühren",
    "tools.holdings": "Depot-Monitor",
    "tools.holdingsSub": "Nachrichten zu den Unternehmen, die du hältst",
    "tools.papers": "Paper-Analyse",
    "tools.papersSub": "Jedes Forschungspapier, einfach erklärt",
    "tools.montecarlo": "Monte-Carlo-Simulator",
    "tools.montecarloSub": "Sparpläne, Trading- und Optionsstrategien, mit PDF",
    "cal.title": "Wirtschaftskalender",
    "cal.sub": "Zinsentscheide der Zentralbanken, wichtige Wirtschaftsdaten, Börsenschließungen und Feiertage, aus offiziellen Quellen, in Ihrer Zeitzone.",
    "cal.todayLabel": "Heute",
    "cal.tomorrow": "Morgen",
    "cal.yesterday": "Gestern",
    "cal.allDay": "Ganztägig",
    "cal.now": "jetzt",
    "cal.inDH": "in {d} T {h} Std",
    "cal.inHM": "in {h} Std {m} Min",
    "cal.inM": "in {m} Min",
    "cal.decision": "{bank}: Zinsentscheid",
    "cal.closed": "{exchange} geschlossen",
    "cal.early": "{exchange} schließt früher",
    "cal.estimated": "voraussichtliches Datum",
    "cal.yourTz": "Zeiten in Ihrer Zeitzone ({tz})",
    "cal.type.public_holiday": "Feiertage",
    "cal.allCountries": "Alle Länder",
    "cal.yourCountries": "Ihre Länder",
    "cal.noFollows": "Folgen Sie Ländern auf dem Globus, um hier danach zu filtern.",
    "cal.addToCal": "Zum Kalender hinzufügen",
    "cal.subscribe": "Abonnieren",
    "cal.subscribeHint": "Kopieren Sie diesen Link in Google Kalender, Apple Kalender oder Outlook („aus URL hinzufügen“). Er aktualisiert sich selbst.",
    "cal.copied": "Link kopiert",
    "cal.source": "Offizielle Quelle",
    "cal.relatedNews": "Nachrichten zu {country}",
    "cal.period": "Zeitraum: {period}",
    "cal.none": "Für diese Filter ist nichts geplant.",
    "cal.error": "Der Kalender ist gerade nicht verfügbar. Bitte versuchen Sie es gleich noch einmal.",
    "cal.comingUp": "Demnächst",
    "cal.fullCalendar": "Ganzer Kalender",
    "cal.euroArea": "Euroraum",
    "cal.note": "Termine und Uhrzeiten stammen von den Zentralbanken, Börsen und Statistikämtern (Link bei jedem Termin). Feiertage: Open-Source-Bibliothek „holidays“ (MIT). Wir zeigen nie Prognosen. Nachrichten und Kontext, keine Finanzberatung.",
    "cal.series.us_cpi": "US-Verbraucherpreise (CPI)",
    "cal.series.us_jobs": "US-Arbeitsmarktbericht",
    "cal.series.us_ppi": "US-Erzeugerpreise (PPI)",
    "cal.series.us_jolts": "US-Stellenangebote (JOLTS)",
    "cal.series.us_eci": "US-Arbeitskostenindex",
    "cal.series.us_gdp": "US-BIP",
    "cal.series.us_pce": "US-Einkommen und Konsumausgaben (PCE)",
    "cal.series.us_trade": "US-Handelsbilanz",
    "cal.series.ea_hicp_flash": "Inflation Euroraum (Schnellschätzung)",
    "cal.series.ea_hicp": "Inflation Euroraum (endgültig)",
    "cal.series.ea_gdp_flash": "BIP Euroraum (vorläufige Schnellschätzung)",
    "cal.series.ea_gdp": "BIP und Beschäftigung Euroraum",
    "cal.series.ea_unemployment": "Arbeitslosigkeit Euroraum",
    "cal.series.ea_retail": "Einzelhandelsumsatz Euroraum",
    "cal.series.uk_cpi": "Verbraucherpreise Vereinigtes Königreich (CPI)",
    "cal.series.uk_gdp_q": "BIP Vereinigtes Königreich (Quartal)",
    "cal.series.uk_gdp_m": "BIP Vereinigtes Königreich (Monat)",
    "cal.series.uk_jobs": "Arbeitsmarkt Vereinigtes Königreich",
    "cal.series.uk_retail": "Einzelhandelsumsatz Vereinigtes Königreich",
    "cal.series.au_cpi": "Verbraucherpreise Australien (CPI)",
    "cal.series.au_jobs": "Arbeitsmarkt Australien",
    "cal.series.au_gdp": "BIP Australien",
    "bank.snb": "Schweizerische Nationalbank",
    "bank.boc": "Bank of Canada",
    "bank.rba": "Reserve Bank of Australia",
    "bank.rbnz": "Reserve Bank of New Zealand",
    "bank.riksbank": "Sveriges Riksbank",
    "bank.norges": "Norges Bank",
    "bank.rbi": "Reserve Bank of India",
    "cal.promise1": "Nur offizielle Quellen",
    "cal.promise2": "Keine Prognosen, nur Termine und Ergebnisse",
    "cal.promise3": "Kostenloser Kalender-Feed",
    "cal.yourTimeShort": "Ihre Zeit",
    "cal.unitD": "Tage",
    "cal.unitH": "Std",
    "cal.unitM": "Min",
    "cal.approxNote": "Ungefähre Uhrzeit: Die Bank legt sie nicht im Voraus fest",
    "cal.then": "Danach:",
    "cal.nextDecisions": "Nächste Zinsentscheide",
    "cal.bankCalendars": "Offizielle Kalender der Banken · Countdown bis zur Bekanntgabe",
    "cal.marketsWeek": "Börsen diese Woche",
    "cal.mktAside": "Schließungen diese Woche: {n} · Zeiten in {tz}",
    "cal.mktNote": "Nur die Haupthandelszeit. Schließungen stammen aus dem offiziellen Feiertagskalender jeder Börse.",
    "cal.exchange": "Börse",
    "cal.rightNow": "Gerade jetzt",
    "cal.mkt.open": "Geöffnet",
    "cal.mkt.pre": "Noch nicht geöffnet",
    "cal.mkt.break": "Mittagspause",
    "cal.mkt.closedToday": "Heute geschlossen",
    "cal.mkt.closed": "Geschlossen",
    "cal.mkt.closesAt": "schließt um {time} (Ihre Zeit)",
    "cal.mkt.opensAt": "öffnet um {time} (Ihre Zeit)",
    "cal.mkt.earlyAt": "Schließt früher um {time}",
    "cal.local": "Ortszeit",
    "cal.country": "Land",
    "cal.types": "Terminarten",
    "cal.group.central_bank": "Zentralbanken",
    "cal.group.data_release": "Wirtschaftsdaten",
    "cal.group.markets": "Börsenschließungen",
    "cal.group.public_holiday": "Feiertage",
    "cal.badge.central_bank": "Zinsentscheid",
    "cal.badge.data_release": "Datenveröffentlichung",
    "cal.badge.market_closed": "Börse geschlossen",
    "cal.badge.early_close": "Früher Handelsschluss",
    "cal.badge.public_holiday": "Feiertag",
    "cal.closesEarly": "früher Handelsschluss",
    "cal.noTrading": "den ganzen Tag kein Handel",
    "cal.released": "Veröffentlicht",
    "cal.seeFigure": "Offiziellen Wert ansehen",
    "cal.sourceShort": "Quelle",
    "cal.news": "Nachrichten",
    "cal.openNote": "{exchange} geöffnet",
    "cal.plusMore": "+{n} weitere",
    "cal.oneEvent": "1 Termin",
    "cal.nEvents": "{n} Termine",
    "cal.oneHoliday": "1 Feiertag",
    "cal.nHolidays": "{n} Feiertage",
    "cal.nowLine": "Jetzt · {time}",
    "cal.weekendClosed": "Wochenende: Börsen geschlossen.",
    "cal.nothingDay": "Nichts geplant.",
    "cal.thisWeek": "Diese Woche",
    "cal.nextWeekLabel": "Nächste Woche",
    "cal.earlier": "Früher in dieser Woche",
    "cal.show": "Anzeigen",
    "cal.tryAll": "Wählen Sie alle Terminarten oder schalten Sie „Ihre Länder“ aus.",
    "cal.reset": "Filter zurücksetzen",
    "cal.prevWeek": "Vorherige Woche",
    "cal.nextWeek": "Nächste Woche",
    "cal.moreWeek": "Folgende Woche anzeigen",
    "cal.subscribeTitle": "Diesen Kalender abonnieren",
    "cal.feedAddress": "Feed-Adresse",
    "cal.copyLink": "Link kopieren",
    "cal.subFine": "Kostenlos, ohne Konto. Folgt den gewählten Filtern. Nachrichten und Kontext, keine Finanzberatung.",
    "cal.impact": "Wirkung",
    "cal.imp.high": "Hoch",
    "cal.imp.medium": "Mittel",
    "cal.imp.low": "Gering",
    "cal.impTip.high": "bewegt meist Zinsen, Währungen und Aktien",
    "cal.impTip.medium": "von Märkten beachtet, bewegt sie seltener",
    "cal.impTip.low": "Hintergrund: Feiertage, kleinere Daten",
    "cal.impNote": "Nach Art des Termins, keine Prognose.",
    "cal.impAll": "Alle",
    "cal.impMediumUp": "Mittel +",
    "cal.impHighOnly": "Nur hoch",
    "cal.nHigh": "{n} mit hoher Wirkung",
    "cal.addShort": "Hinzufügen",
};
